import { render, staticRenderFns } from "./CharacterTable.vue?vue&type=template&id=3f5fe87e&lang=pug&"
import script from "./CharacterTable.vue?vue&type=script&lang=js&"
export * from "./CharacterTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CharacterTable.vue"
export default component.exports